const orgSearchStrings = {
  payingOrgsAutocomplete: "Til hvilke organisasjoner skal kravet sendes?",
  payingOrgsAutocompletePlaceholder: "@:commonStrings.orgAutocompleteHint",
  payingOrgsAutocompleteValidationName: "Organisasjoner",
  orgInUse: "Du har valgt '{0}' som mottaker i et eller flere krav under, fjern derfra først!",
  noDataText: "@:commonStrings.noOrgsFound"
};

export default orgSearchStrings;